//Libs
import React, { Component, Fragment } from 'react';
import randomColor from 'randomcolor';
//Componentes Material
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
//Ícones
import PersonIcon from '@material-ui/icons/Person';
//Gráficos
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend, AreaChart, XAxis, YAxis, Area } from 'recharts';
//Components
import CenteredCircularProgress from '../CenteredCircularProgress';
//Controllers
import RelatorioController from '../../controllers/RelatorioController';
//Modelos
import Clientes from '../../models/relatorios/Clientes';

/**
 * Componente para exibir os gráficos dos relatórios de clientes
 */
class RelatorioClientes extends Component {
    constructor(props) {
        super(props);
        //Controllers
        this.relatorioController = new RelatorioController();
        //Estado inicial
        this.state = {
            carregando: true,
            dados: Clientes.clone({ }),
            erros: [ ]
        };
    }

    async componentDidMount() {
        //Consulta os dados da API
        const result = await this.relatorioController.clientes();
        //Caso a consulta ocorra com sucesso
        if (result.sucesso) {
            this.setState({ carregando: false, dados: result.dados });
        } else {
            this.setState({ carregando: false, erros: result.erros });
        }

    }

    /**
     * Renderiza o gráfico de clientes agrupados por tipo de patologia
     * @return {Object} Retorna o componente do gráfico
     */
    renderizarGraficoPatologia() {
        const { dados } = this.state;
        const cores = randomColor({ count: dados.patologia.length, seed: 0 });

        return (
            <ResponsiveContainer height={200} >
                <PieChart>
                    <Pie data={dados.patologia} dataKey="quantidade" nameKey="rotulo">
                        { dados.patologia.map((item, i) => (<Cell key={item.rotulo} fill={cores[i]} />)) }
                    </Pie>
                    <Tooltip />
                    <Legend align="left" verticalAlign="middle" layout="vertical" />
                </PieChart>
            </ResponsiveContainer>
        );
    }

    /**
     * Renderiza o gráfico de clientes agrupados por gênero
     * @return {Object} Retorna o componente do gráfico
     */
    renderizarGraficoGenero() {
        const { dados } = this.state;
        const cores = randomColor({ count: dados.genero.length, seed: 0 });

        return (
            <ResponsiveContainer height={200} >
                <PieChart>
                    <Pie data={dados.genero} dataKey="quantidade" nameKey="rotulo">
                        { dados.genero.map((item, i) => (<Cell key={item.rotulo} fill={cores[i]} />)) }
                    </Pie>
                    <Tooltip />
                    <Legend align="left" verticalAlign="middle" layout="vertical" />
                </PieChart>
            </ResponsiveContainer>
        );
    }

    /**
     * Renderiza o gráfico de clientes agrupados por faixa etária
     * @return {Object} Retorna o componente do gráfico
     */
    renderizarGraficoIdade() {
        const { dados } = this.state;

        return (
            <ResponsiveContainer height={200} >
                <AreaChart data={dados.idade} >
                    <XAxis dataKey="rotulo" />
                    <YAxis allowDecimals={false} />
                    <Area dataKey="quantidade" stroke="#8884d8" fill="#8884d8" />
                    <Tooltip />
                </AreaChart>
            </ResponsiveContainer>
        );
    }

    /**
     * Renderiza o gráfico de clientes agrupados por profissão
     * @return {Object} Retorna o componente do gráfico
     */
    renderizarGraficoProfissao() {
        const { dados } = this.state;
        const cores = randomColor({ count: dados.profissao.length, seed: 0 });

        return (
            <ResponsiveContainer height={200} >
                <PieChart>
                    <Pie data={dados.profissao} dataKey="quantidade" nameKey="rotulo">
                        { dados.profissao.map((item, i) => (<Cell key={item.rotulo} fill={cores[i]} />)) }
                    </Pie>
                    <Tooltip />
                    <Legend align="left" verticalAlign="middle" layout="vertical" />
                </PieChart>
            </ResponsiveContainer>
        );
    }

    /**
     * Renderiza o gráfico de clientes agrupados por bairro
     * @return {Object} Retorna o componente do gráfico
     */
    renderizarGraficoBairro() {
        const { dados } = this.state;
        const cores = randomColor({ count: dados.bairro.length, seed: 0 });

        return (
            <ResponsiveContainer height={200} >
                <PieChart>
                    <Pie data={dados.bairro} dataKey="quantidade" nameKey="rotulo">
                        { dados.bairro.map((item, i) => (<Cell key={item.rotulo} fill={cores[i]} />)) }
                    </Pie>
                    <Tooltip />
                    <Legend align="left" verticalAlign="middle" layout="vertical" />
                </PieChart>
            </ResponsiveContainer>
        );
    }

    render() {
        const { carregando } = this.state;
        return (
            <Fragment>
                <Grid item xs={12} sm={12} md={8} >
                    <Card>
                        <CardHeader avatar={<PersonIcon />} title="Clientes por idade" />
                        <CardContent>
                            { carregando && <CenteredCircularProgress />  }
                            { !carregando && this.renderizarGraficoIdade() }
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4} >
                    <Card>
                        <CardHeader avatar={<PersonIcon />} title="Clientes por gênero" />
                        <CardContent>
                            { carregando && <CenteredCircularProgress />  }
                            { !carregando && this.renderizarGraficoGenero() }
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4} >
                    <Card>
                        <CardHeader avatar={<PersonIcon />} title="Clientes por patologia" />
                        <CardContent>
                            { carregando && <CenteredCircularProgress />  }
                            { !carregando && this.renderizarGraficoPatologia() }
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4} >
                    <Card>
                        <CardHeader avatar={<PersonIcon />} title="Clientes por profissão" />
                        <CardContent>
                            { carregando && <CenteredCircularProgress />  }
                            { !carregando && this.renderizarGraficoProfissao() }
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4} >
                    <Card>
                        <CardHeader avatar={<PersonIcon />} title="Clientes por bairro" />
                        <CardContent>
                            { carregando && <CenteredCircularProgress />  }
                            { !carregando && this.renderizarGraficoBairro() }
                        </CardContent>
                    </Card>
                </Grid>
            </Fragment>
        );
    }
}

export default RelatorioClientes;